import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth-context';

export function ProtectedRoute() {
  const { user, isLoading, sessionLost } = useAuth();
  const location = useLocation();

  // The silent session restore must finish before deciding, or a reload
  // would bounce an authenticated user to the login screen.
  if (isLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // `from` brings the person back to where they were once they sign in;
  // `reason` lets the login screen say why they are looking at it.
  if (!user) {
    return (
      <Navigate
        to="/"
        replace
        state={{ from: `${location.pathname}${location.search}`, ...(sessionLost ? { reason: 'expired' } : {}) }}
      />
    );
  }

  return <Outlet />;
}
